var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"offset-top-1"},[_c('VBanner'),_c('transition',{attrs:{"name":"fade","mode":"out-in","appear":""}},[(_vm.isLoading)?_c('VSpinner',{key:"busy",staticClass:"offset-top-2"}):_c('router-view',_vm._b({key:"content",on:{"captchaReload":_vm.onCaptchaReload}},'router-view',_vm.response,false))],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }